<template>
  <div>
    <div class="job-information-field">
      <div>Job Description (optional):</div>
      <textarea rows="3" cols="45" v-model="jobDescription"></textarea>
    </div>
    <div class="job-information-field">
      <div>E-mail (optional):</div>
      <input type="email" v-model="email" />
    </div>

    <div class="dividor"></div>

    <div>
      <div>License Agreement:</div>
      <div>
        <form>
          <label class="block">
            <input
              type="radio"
              name="license-type"
              value="FULL_ACADEMIC"
              v-model="license"
            />
            I agree with the academic license agreement and confirm that I
            will use the software exclusively for non-commercial purposes.
          </label>

          <label class="block">
            <input
              type="radio"
              name="license-type"
              value="GRAFTED_SEQUENCES_ONLY"
              v-model="license"
            />
            I am a commercial user, I own a LoopGrafter commercial license and
            I do not own a MODELLER commercial license.
          </label>

          <label class="block">
            <input
              type="radio"
              name="license-type"
              value="MODELLER_ONLY"
              v-model="license"
            />
            I am a commercial user, I own a LoopGrafter commercial license and
            I own a commercial license for MODELLER only (I do not own 
            a licence for Rosetta).
          </label>

          <label class="block">
            <input
              type="radio"
              name="license-type"
              value="FULL_COMMERCIAL"
              v-model="license"
            />
            I am a commercial user, I own a LoopGrafter commercial license and
            I own a commercial license for both Rosetta and MODELLER.
          </label>

          <div
            v-if="license === 'GRAFTED_SEQUENCES_ONLY'"
            class="license-warning"
          >
            Only sequences for grafted designs will be generated. 3D models of
            the grafted designs will not be produced.
          </div>
          <div v-if="license === 'MODELLER_ONLY'" class="license-warning">
            Sequences for all grafted designs will be generated. 3D models of
            the grafted designs will be evaluated using only MODELLER scores.
          </div>
        </form>
      </div>
    </div>
    <LabelButton
      @click="beginGraftDesign"
      :spinTillResolved="graftDesignState"
      class="labelButton"
    >
      Launch Graft Design
    </LabelButton>
  </div>
</template>

<script>
import LabelButton from "../components/PanelButtons/TextLabelButton";
import { mapActions } from "vuex";

export default {
  components: {
    LabelButton,
  },

  data() {
    return {
      license: "FULL_ACADEMIC",
      jobDescription: null,
      email: null,

      graftDesignState: null,
    };
  },

  methods: {
    ...mapActions(["resolveProposedProteins"]),

    async beginGraftDesign() {
      this.graftDesignState = this.resolveProposedProteins({
        license: this.license.startsWith("FULL") ? "FULL" : this.license,
        jobDescription: this.jobDescription,
        email: this.email,
      });
      await this.graftDesignState;
      debugger;
      this.$router.push({ name: "graft-design" });
    },
  },
};
</script>

<style scoped>
.block {
  display: block;
}

.labelButton {
  width: fit-content;
  /* height: 30px; */
  margin: 10px;
  /* background: var(--gradient); */
}

.job-information-field {
  margin: 0px 10px;
}

.license-warning {
  color: var(--scaffold);
}
</style>
